import React from "react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import CommentIcon from "@mui/icons-material/Comment";

import { isEmptyArray, isEmptyObject } from "../../../util";
import { updateStudentMarks, updateUserActivityRating } from "../../../api/markingApi";

import DismissIcon from "../../../assets/images/Dismiss.svg";
import GeneralCommentIcon from "../../../assets/images/GeneralCommentIcon.png"  
import SaveIcon from "../../../assets/images/Save.png";


import "../../../assets/stlyes/MarkEditor.scss";
import { useNavigate } from "react-router-dom";
import { success } from "../../Shared";
import { SUCCESS,  SchoolPages, Common  } from "../../../helper";

const MarkHeader = (props) => {
  const { year, _description, generalComments, finalUpdatedData, setIsLoading, _fetchDescription, _fetchDescriptionMark, generalComment, setModalOn } = props;
  const navigate = useNavigate();

  const _pupilCategoryAttainment = async () => {
    setIsLoading(true);
    const response = await updateStudentMarks(finalUpdatedData && finalUpdatedData);
    await updateUserActivityRating(finalUpdatedData && finalUpdatedData);
    if (!isEmptyObject(response.Items)) {
      _fetchDescription();
      _fetchDescriptionMark();
      generalComment();
      success(SUCCESS.MARK_UPDATED)
      navigate(SchoolPages.subjectMarkings);
    }
    setIsLoading(false);
  }

  const previousPage = () => { navigate(SchoolPages.subjectMarkings); }
  
  return (
    <div className="row header-container">
      <div className="col-md-10 d-flex justify-content-between">
        <p className=" marking-editor-page-title"> Y{year}: {_description} &nbsp;{!isEmptyArray(generalComments) && <OverlayTrigger overlay={<Tooltip id="tooltip-top">{generalComments}</Tooltip>}>
          <span className="d-inline-block"><CommentIcon /></span>
        </OverlayTrigger>}</p>
        <div className="cancel-save-buttons d-flex flex-column">
          <div className="mark-buttons-cloumn">
            <button className="mark-upload-evidenece-btn d-flex justify-content-between" onClick={() => setModalOn(true)}>
              <span>{Common.AddGeneralComments}</span>
              <img src={GeneralCommentIcon} alt="" />
            </button>
          </div>
          <div className="d-flex " style={{ gap: "10px" }}>
            <div className="save-button-col">
              <button className="save-button" onClick={() => _pupilCategoryAttainment()}>
                <img src={SaveIcon} alt="Save" />
                <p style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>{Common.Save}</p>
              </button>
            </div>
            <div className="cancel-button-col">
              <button className="cancel-button" onClick={() => previousPage()}>
                <img src={DismissIcon} alt="Save" />
                <p style={{ display: "flex", justifyContent: "center", alignItems: "center", color: "#565656" }}>{Common.Cancel}</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { MarkHeader }